.main-content#apc-react-root
    unless loaded
        .spinner